/** @license @dairyfarm/eval-web v3.0.0
* Copyright 2020 Texas A&M Center for Applied Technology, 
* Texas A&M Engineering Experiment Station, The Texas A&M 
* University System.
* 
* This source code/schema and any derivative work is Texas 
* A&M Engineering Experiment Station intellectual property 
* and protected by copyright law. Usage is restricted solely 
* to the FARM Animal Care and Environmental Stewardship 
* programs administered by the National Milk Producers 
* Federation. Dissemination of this source code and/or 
* derivative work creation is strictly prohibited without 
* express written permission from the Texas A&M Engineering 
* Experiment Station.
*/
import { History } from "history";
import { ActionType, createAction, createAsyncAction } from "typesafe-actions";
import { REDIRECT } from "../actions";
import { IdentityToken, OAuthConfiguration } from "./../../utils/auth";

export const redirect = createAction(
  REDIRECT,
  action => (uri: string, history: History<any>) => action({ uri, history })
);


interface TokenRequestPayload {
  code: string;
  oauthConfig: OAuthConfiguration;
  history: History<any>;
}

interface TokensReceivedPayload {
  dfdmToken: IdentityToken;
}


export const fetchOAuthConfigActions = createAsyncAction(
  "OAUTH_CONFIG_REQUEST",
  "OAUTH_CONFIG_RESPONSE",
  "OAUTH_CONFIG_FAILURE"
)<string, OAuthConfiguration, Error>();

export const fetchTokenActions = createAsyncAction(
  "FETCH_TOKEN_REQUEST",
  "FETCH_TOKEN_RESPONSE",
  "FETCH_TOKEN_FAILURE"
)<TokenRequestPayload, TokensReceivedPayload, Error>();

// convenience API
export const fetchToken = (
  authorizationCode: string,
  config: OAuthConfiguration,
  history: History<any>
) =>
  fetchTokenActions.request({
    code: authorizationCode,
    oauthConfig: config,
    history,
  });

export const cacheToken = createAction(
  "CACHE_TOKEN",
  action => (token: string) => action(token)
);
export const tokenCached = createAction("CACHE_TOKEN_SUCCESS");
export const tokenCleared = createAction('CLEAR_TOKEN');

export const signOutAction = createAction("SIGN_OUT");

export type SessionAction =
  | ActionType<typeof redirect>
  | ActionType<typeof fetchOAuthConfigActions>
  | ActionType<typeof fetchTokenActions>
  | ActionType<typeof cacheToken>
  | ActionType<typeof tokenCached>
  | ActionType<typeof signOutAction>;
